import { persistor } from "../../../store";
import { clearDeeplink } from "../../../store/persistStore";
import { clearLocalStorage } from "../../../store/persistStore";
import userManager from "../OIDCAuthHandler";
import AppSettings from "../../../utils/appSettings";

export class LogoutCommand {
  async execute() {
    localStorage.removeItem("token");
    await userManager.removeUser();
    clearLocalStorage();
    clearDeeplink();
    await persistor.purge();

    const logoutUrl = `${AppSettings.identityServer}/account/logout?clientid=${AppSettings.clientId}&returnurl=${window.location.origin}`;
    window.location.replace(logoutUrl);
  }
}
